import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { shopService } from '@/services/shop';

export default function () {
    const crudAction = useCrudActions();

    const { list, total, fetchList } = useBaseListView({ request: shopService.item.list });

    const actions = {
        remove: crudAction.confirmAndRemove({
            request: shopService.item.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, actions };
}
